import axios from "axios";
import { baseUrl } from "../util";

export const getCompanySummary = ({ id, setObjects, isShared = false }) => {
  const url = isShared
    ? baseUrl + "/api/ardash/" + id + "/company-summary?shared=true"
    : baseUrl + "/api/ardash/" + id + "/company-summary";

  var config = {
    method: "get",
    url: url,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);
    })
    .catch(function (error) {
      if (error.response?.status === 403) {
        console.log("Access denied - insufficient permissions");
        // Handle access denied for shared users
        setObjects(null); // Clear any existing data
      } else {
        console.log(error);
      }
    });
};
